module.exports = __webpack_public_path__ + "static/img/news13.eaf04cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news13.png
// module id = xg/5
// module chunks = 1